interface IServerErrorMessage {
    ctx: object;
    loc: string[];
    msg: string;
    type: string;
}

export interface IStandardErrorResponse {
    error_code?: string;
    /**
     * In almost all cases the status is "error"
     */
    status: string;
    /**
     * In almost all cases this is a message that can be shown directly to the user
     * This string is not allowed to be empty.
     */
    msg: string;
    messages?: IServerErrorMessage[];
}

export const isStandardErrorResponse = (err: any): err is IStandardErrorResponse => {
    return err && typeof err === 'object' && 'status' in err && 'msg' in err && err.msg;
};

export const getFriendlyErrorMessage = (error: IStandardErrorResponse): string => {
    if (error.messages && error.messages.length === 1 && error.messages[0].msg) {
        return error.messages[0].msg;
    } else {
        return error.msg;
    }
};